import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { usePaddle } from '~/util';
import { getPricing, isLifetimePlan } from '~/Config/Stripe';
import Modal from '~/Containers/Global/Modal/Modal';
import { UPGRADE_TO_LIFETIME_MODAL } from '~/Config/Modals';
import { closeModal } from '~/Redux/Modules/Modal';
import StripePermittedView from '~/Components/Global/StripePermittedView';
import StripeLifetimeUpgrade from './StripeLifetimeUpgrade';
import PaddleLifetimeUpgrade from './PaddleLifetimeUpgrade';

import './ManageSubscription.scss';

const UpgradeToLifetime = ({ modalId }) => {
  const dispatch = useDispatch();
  const { modalData } = useSelector(({ Modal }) => Modal);
  const usePaddleValue = usePaddle();
  const user = useSelector(({ User }) => User.data);

  const pricingPlans = useCallback(getPricing(), []);

  const activeSubscription =
    user?.subscriptions?.find(
      subscription => !subscription.ends_at || new Date(subscription.ends_at) > new Date()
    ) || {};

  const activePlan = Object.values(pricingPlans).find(
    ({ plan, commonIdentifier }) =>
      plan == activeSubscription.stripe_price || commonIdentifier == activeSubscription.stripe_price
  );

  const isLifetime = !!activePlan?.isLifetime;
  console.log('UpgradeToLifetime', activeSubscription, 'isLifetime', isLifetime);

  const handleClose = result => {
    dispatch(closeModal(modalId));
    if (result) {
      modalData.confirmPromise?.resolve();
    } else {
      modalData.confirmPromise?.reject();
    }
  };

  return (
    <Modal
      overlayClassName="upgrade-to-lifetime-modal"
      id={modalId}
      ariaHideApp={false}
      onClose={() => handleClose(false)}
    >
      {isLifetime ? (
        <p className="text-center">
          You are already a lifetime subscriber, thank you for your support!
        </p>
      ) : (
        <StripePermittedView>
          {usePaddleValue ? (
            <PaddleLifetimeUpgrade modalId={modalId} onClose={handleClose} />
          ) : (
            <StripeLifetimeUpgrade modalId={modalId} onClose={handleClose} />
          )}
        </StripePermittedView>
      )}
    </Modal>
  );
};

UpgradeToLifetime.propTypes = {
  modalId: PropTypes.string,
};

UpgradeToLifetime.defaultProps = {
  modalId: UPGRADE_TO_LIFETIME_MODAL,
};

export default UpgradeToLifetime;
